import {uploadReagent, uploadSample, uploadExperiment, uploadAll, downReagent, downSample, chooseSamTem, uploadRawFile, replaceRawFile, downloadRawFile, getRawFileList} from 'api/upload'
const upload = {
  state: {
  },
  mutations: {
  },
  actions: {
    uploadReagent ({commit}, params) {
      return new Promise((resolve, reject) => {
        uploadReagent(params).then((res) => {
          // commit('SET_UPLOADREA', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    uploadSample ({commit}, params) {
      return new Promise((resolve, reject) => {
        uploadSample(params).then((res) => {
          // commit('SET_UPLOADSAM', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    uploadExperiment ({commit}, params) {
      return new Promise((resolve, reject) => {
        uploadExperiment(params).then((res) => {
          // commit('SET_UPLOADEXP', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    uploadAll ({commit}, params) {
      return new Promise((resolve, reject) => {
        uploadAll(params).then((res) => {
          // commit('SET_UPLOADALL', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    downReagent ({commit}, params) {
      return new Promise((resolve, reject) => {
        downReagent(params).then((res) => {
          // commit('SET_DOWNREA', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    downSample ({commit}, params) {
      return new Promise((resolve, reject) => {
        downSample(params).then((res) => {
          // commit('SET_DOWNSAM', res.result)
          // console.log(res)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    chooseSamTem ({commit}, params) {
      return new Promise((resolve, reject) => {
        chooseSamTem(params).then((res) => {
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    // rawFile upload
    uploadRawFile ({commit}, params) {
      return new Promise((resolve, reject) => {
        uploadRawFile(params).then((res) => {
          // commit('SET_UPLOADREA', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    replaceRawFile ({commit}, params) {
      return new Promise((resolve, reject) => {
        replaceRawFile(params).then((res) => {
          // commit('SET_UPLOADREA', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    downloadRawFile ({commit}, params) {
      return new Promise((resolve, reject) => {
        downloadRawFile(params).then((res) => {
          // commit('SET_UPLOADREA', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getRawFileList ({commit}, params) {
      return new Promise((resolve, reject) => {
        getRawFileList(params).then((res) => {
          // commit('SET_UPLOADREA', res.result)
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
export default upload



// WEBPACK FOOTER //
// ./src/store/modules/upload.js